<div class="content-wrapper" style="margin-top: 30px">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="width: 97%"
  >
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 20px;
              height: 35px;
              display: flex;
              align-items: center;
              gap: 5px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            [disabled]="isLoading"
            (click)="refreshDownloads()"
          >
            <i class="las la-sync"></i>
            {{ 'record.table.reload' | translate }}
          </button>
        </div>
      </div>
    </div>
    <form>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" sortable="dateCreated" (sort)="onSort($event)">
              {{ 'record.table.date' | translate }}
            </th>
            <th scope="col" sortable="query" (sort)="onSort($event)">
              {{ 'record.table.consultation' | translate }}
            </th>
            <th scope="col" sortable="userName" (sort)="onSort($event)">
              {{ 'record.table.user' | translate }}
            </th>
            <th scope="col" sortable="filter" (sort)="onSort($event)">
              {{ 'record.table.filter' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.status.title' | translate }}
            </th>
            <th scope="col">{{ 'record.table.opt' | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="isLoading">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoading">
          <tr *ngFor="let download of downloads">
            <td>{{ download.dateCreated | tableDate }}</td>
            <td>{{ download.query }}</td>
            <td>{{ download.userName }}</td>
            <td>{{ invertirFormatoFecha(download.filter) }}</td>
            <td>
              <div
                class="status-badge"
                [ngStyle]="{
                  'background-color':
                    download.status === 'Completed'
                      ? '#28a745'
                      : download.status === 'Processing'
                      ? '#17a2b8'
                      : download.status === 'Failed'
                      ? '#dc3545'
                      : download.status === 'Pending'
                      ? '#ffc107'
                      : ''
                }"
              >
                {{ translateStatus(download.status) }}
              </div>
            </td>
            <td>
              <button
                (click)="
                  downloadReport(
                    download.id,
                    download.dateCreated,
                    download.query
                  )
                "
                [disabled]="download.status !== 'Completed'"
                style="border: none; padding: 0; background: transparent"
                [ngStyle]="{
                  cursor:
                    download.status !== 'Completed' ? 'default' : 'pointer',
                  opacity: download.status !== 'Completed' ? '0.5' : '1'
                }"
              >
                <i class="las la-download font-25"></i>
              </button>
              <button
                (click)="deleteDownload(download.id)"
                style="border: none; padding: 0; background: transparent"
              >
                <i class="lar la-trash-alt text-danger font-25"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        *ngIf="downloads && downloads.length <= 0"
        class="d-flex justify-content-center"
      >
        <span>{{ 'noDataAvailable' | translate }}</span>
      </div>
    </form>
  </div>

  <div class="d-flex justify-content-center p-2" *ngIf="downloads.length > 0">
    <ngb-pagination
      #paginador
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="5"
      [rotate]="true"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshDownloads()"
    >
    </ngb-pagination>

    <!--
    <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
      <option [ngValue]="2">2 items per page</option>
      <option [ngValue]="4">4 items per page</option>
      <option [ngValue]="6">6 items per page</option>
    </select>
    -->
  </div>
</div>
